import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import RandomValuePool from '../common/RandomValuePool';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import Game from '../scenes/Game';
import UIAssetKeys from '../UIAssetKeys';

export default class QuestionDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Game} scene 
   */
  constructor(scene) {
    super(scene);

    this.delegate = scene;

    this.isCorrect = null;
    this.isbusy = false;

    this.correctIndexPool = new RandomValuePool([1,2]);
    this.incorrectIndexPool = new RandomValuePool([1,2]);
    this.voCorrectIndexPool = new RandomValuePool([1,2]);
    this.voIncorrectIndexPool = new RandomValuePool([1,2]);

    this.txtQuestionContainer = this.scene.add.container();

    this.txtQuestion = ABCyaPhaser.Text.addText(0,0,gameData.fontSizes.lg, 0xffffff, FontKeys._asapbold, '2 - 1 = ', this.txtQuestionContainer).setOrigin(0);

    this.txtAnswer = ABCyaPhaser.Text.addText(this.txtQuestion.width + 12,0,gameData.fontSizes.lg,0xffffff, FontKeys._asapbold, '?', this.txtQuestionContainer).setOrigin(0);
    this.txtQuestionContainer.x = this.scene.scale.width / 2 - this.txtQuestionContainer.getBounds().width / 2 - 20;
    this.add(this.txtQuestionContainer);

    this.btnCheck = ABCyaPhaser.Images.addImage(840,0,UIAssetKeys._BtnGoAlt, this).setInteractive();
    this.btnCheck.y = this.btnCheck.height / 2 - 10;
    this.btnCheckLabel = ABCyaPhaser.Images.addImage(this.btnCheck.x,this.btnCheck.y + this.btnCheck.height / 2 + 20,UIAssetKeys._Label_Check, this);
    this.btnCheck.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickCheck, this);

    this.txtQuestionContainer.alpha = 0;
  }

  clickCheck () {
    this.delegate.checkAnswer();
  }

  beginFeedbackDisplay (question, userNum) {
    this.isbusy = true;
    this.txtAnswer.text = userNum.toString();
    this.isCorrect = question.answer === userNum;
    if (this.isCorrect) {
      this.showCorrect();
    }
    else {
      this.showIncorrect();
    }
    this.scene.time.delayedCall(1600, this.feedbackFinished, null, this);
  }

  showCorrect (muted) {
    if (muted !== true) {
      ABCyaPhaser.Audio.playOneShot(`correct${this.incorrectIndexPool.getValue()}`, this.scene);
      ABCyaPhaser.Audio.playOneShot(`vo_correct${this.voIncorrectIndexPool.getValue()}`, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    }

    this.txtAnswer.setColor('#84b53c');
  }

  showIncorrect(muted) {
    if (muted !== true) {
      ABCyaPhaser.Audio.playOneShot(`incorrect${this.correctIndexPool.getValue()}`, this.scene);
      ABCyaPhaser.Audio.playOneShot(`vo_incorrect${this.voCorrectIndexPool.getValue()}`, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }

    this.txtAnswer.setColor('#e01737');
  }

  feedbackFinished () {
    if (this.isCorrect) {
      this.delegate.nextQuestion();
    }
    else {
      this.txtAnswer.text = '?';
      this.txtAnswer.setColor('#ffffff');
      this.delegate.retryQuestion();
    }
    this.isbusy = false;
  }

  setQuestion (value) {
    this.txtAnswer.setColor('#ffffff');
    this.txtQuestion.text = `${value.num1} - ${value.num2} = `;
    this.txtAnswer.text = '?';
    this.txtAnswer.x = this.txtQuestion.width + 12;
    this.txtQuestionContainer.x = this.scene.scale.width / 2 - this.txtQuestionContainer.getBounds().width / 2 - 20;
  }

  setAnswer (value) {
    this.txtAnswer.text = value.toString();
  }

  beginShowQuestion () {
    ABCyaPhaser.Tweens.addTween(this.txtQuestionContainer, 440, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  }
}